/* Our Walks — client-side filter / search / sort for the walks grid.
 *
 * Binds the control bar (tyt-walks-control-bar) to the grid (tyt-walks-archive).
 * Four facet DROPDOWNS (country / trail / distance / difficulty) behind a
 * collapsible "Filters" button, a main search box and a Newest/Oldest sort.
 * Country and Trail dropdowns have their own in-menu search. Filtering is AND
 * across facets; a facet set to "all" is ignored. Sorting reorders the card
 * nodes in place, keeping the dashed "next walk" placeholder last. No-JS users
 * see every card.
 */
(function () {
  'use strict';

  var FACETS = ['country', 'trail', 'distance', 'difficulty'];

  function init() {
    var bar = document.querySelector('[data-tyt-walks-control-bar]');
    var archive = document.querySelector('[data-tyt-walks-archive]');
    if (!archive) return;
    var grid = archive.querySelector('[data-tyt-walks-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-tyt-walk-card]'));
    var placeholder = grid.querySelector('.tyt-walk-next');
    var countEl = archive.querySelector('[data-tyt-walks-count]');
    var sortLabelEl = archive.querySelector('[data-tyt-walks-sort]');
    var noResults = archive.querySelector('[data-tyt-walks-no-results]');
    var filterCountEl = bar ? bar.querySelector('[data-tyt-walks-filter-count]') : null;

    var state = { country: 'all', trail: 'all', distance: 'all', difficulty: 'all', query: '', sort: 'newest' };

    function activeCount() {
      var n = 0;
      for (var i = 0; i < FACETS.length; i++) if (state[FACETS[i]] !== 'all') n++;
      if (state.query) n++;
      return n;
    }

    function matches(card) {
      for (var i = 0; i < FACETS.length; i++) {
        var f = FACETS[i];
        if (state[f] !== 'all' && (card.getAttribute('data-' + f) || '') !== state[f]) return false;
      }
      if (state.query && (card.getAttribute('data-search-text') || '').indexOf(state.query) === -1) return false;
      return true;
    }

    function apply() {
      cards.sort(function (a, b) {
        var ta = parseInt(a.getAttribute('data-published-time'), 10) || 0;
        var tb = parseInt(b.getAttribute('data-published-time'), 10) || 0;
        return state.sort === 'oldest' ? ta - tb : tb - ta;
      });
      var visible = 0;
      cards.forEach(function (card) {
        var ok = matches(card);
        card.hidden = !ok;
        card.style.display = ok ? '' : 'none';
        if (ok) visible++;
        if (placeholder) grid.insertBefore(card, placeholder);
        else grid.appendChild(card);
      });
      if (countEl) countEl.textContent = visible;
      if (sortLabelEl) sortLabelEl.textContent = state.sort === 'oldest' ? 'oldest first' : 'newest first';
      if (noResults) noResults.hidden = cards.length === 0 || visible !== 0;
      if (filterCountEl) {
        var ac = activeCount();
        filterCountEl.textContent = ac;
        filterCountEl.hidden = ac === 0;
      }
    }

    if (bar) {
      // ── collapsible "Filters" panel ──────────────────────────────────────
      var fToggle = bar.querySelector('[data-tyt-walks-filter-toggle]');
      var fPanel = bar.querySelector('[data-tyt-walks-facets]');
      if (fToggle && fPanel) {
        fToggle.addEventListener('click', function () {
          var open = fPanel.hidden;
          fPanel.hidden = !open;
          fToggle.setAttribute('aria-expanded', String(open));
        });
      }

      // ── facet dropdowns ──────────────────────────────────────────────────
      var dds = Array.prototype.slice.call(bar.querySelectorAll('[data-tyt-walks-dd]'));

      function closeAllDD(except) {
        dds.forEach(function (dd) {
          if (dd === except) return;
          var m = dd.querySelector('[data-tyt-walks-dd-menu]');
          var t = dd.querySelector('[data-tyt-walks-dd-toggle]');
          if (m) m.hidden = true;
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }

      function filterOptions(dd, q) {
        dd.querySelectorAll('[data-tyt-walks-dd-option]').forEach(function (opt) {
          if (opt.getAttribute('data-value') === 'all') { opt.hidden = false; return; }
          var hay = opt.getAttribute('data-search') || '';
          opt.hidden = q !== '' && hay.indexOf(q) === -1;
        });
      }

      dds.forEach(function (dd) {
        var toggle = dd.querySelector('[data-tyt-walks-dd-toggle]');
        var menu = dd.querySelector('[data-tyt-walks-dd-menu]');
        var valueEl = dd.querySelector('[data-tyt-walks-dd-value]');
        var search = dd.querySelector('[data-tyt-walks-dd-search]');

        if (toggle && menu) {
          toggle.addEventListener('click', function (e) {
            e.stopPropagation();
            var open = menu.hidden;
            closeAllDD(dd);
            menu.hidden = !open;
            toggle.setAttribute('aria-expanded', String(open));
            if (open && search) { search.value = ''; filterOptions(dd, ''); search.focus(); }
          });
        }
        if (menu) menu.addEventListener('click', function (e) { e.stopPropagation(); });
        if (search) {
          search.addEventListener('input', function () { filterOptions(dd, search.value.trim().toLowerCase()); });
        }

        dd.querySelectorAll('[data-tyt-walks-dd-option]').forEach(function (opt) {
          var choose = function () {
            var facet = opt.getAttribute('data-facet');
            state[facet] = opt.getAttribute('data-value');
            dd.querySelectorAll('[data-tyt-walks-dd-option]').forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
            opt.setAttribute('aria-selected', 'true');
            if (valueEl) valueEl.textContent = opt.textContent.trim();
            if (menu) menu.hidden = true;
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
            dd.classList.toggle('is-active', state[facet] !== 'all');
            apply();
          };
          opt.addEventListener('click', choose);
          opt.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); }
          });
        });
      });

      document.addEventListener('click', function () { closeAllDD(null); });
      /* Touch: iOS Safari does not reliably fire a click on `document` for a tap
         that lands on a non-interactive element, so the line above can silently
         fail on a phone and leave the menu stuck open over the results. A
         pointerdown always fires.
         Guarded to non-mouse pointers, so with a mouse NOTHING changes: the click
         handler above still does the closing, on release, exactly as before.
         Containment-checked rather than trusting stopPropagation, because
         pointerdown runs BEFORE click — the toggle's own stopPropagation has not
         happened yet, so a bare close here would be undone (and the menu
         re-opened) by the click that follows. */
      document.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        if (e.target && e.target.closest && e.target.closest('[data-tyt-walks-dd]')) return;
        closeAllDD(null);
      });

      // ── main search ──────────────────────────────────────────────────────
      var mainSearch = bar.querySelector('[data-tyt-walks-search-input]');
      if (mainSearch) {
        var t;
        mainSearch.addEventListener('input', function () {
          clearTimeout(t);
          t = setTimeout(function () { state.query = mainSearch.value.trim().toLowerCase(); apply(); }, 120);
        });
      }

      // ── sort menu ────────────────────────────────────────────────────────
      var sortWrap = bar.querySelector('[data-tyt-walks-sort]');
      if (sortWrap) {
        var sToggle = sortWrap.querySelector('[data-tyt-walks-sort-toggle]');
        var sMenu = sortWrap.querySelector('.tyt-walks-sort__menu');
        var sValue = sortWrap.querySelector('[data-tyt-walks-sort-value]');
        if (sToggle && sMenu) {
          sToggle.addEventListener('click', function (e) {
            e.stopPropagation();
            var open = sMenu.hidden;
            sMenu.hidden = !open;
            sToggle.setAttribute('aria-expanded', String(open));
          });
          sMenu.querySelectorAll('[data-tyt-walks-sort-option]').forEach(function (opt) {
            opt.addEventListener('click', function () {
              state.sort = opt.getAttribute('data-sort');
              if (sValue) sValue.textContent = opt.getAttribute('data-label');
              sMenu.querySelectorAll('[role="option"]').forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
              opt.setAttribute('aria-selected', 'true');
              sMenu.hidden = true;
              sToggle.setAttribute('aria-expanded', 'false');
              apply();
            });
          });
          document.addEventListener('click', function (e) {
            if (!sortWrap.contains(e.target)) { sMenu.hidden = true; sToggle.setAttribute('aria-expanded', 'false'); }
          });
          /* Touch: iOS Safari does not reliably fire a click on `document` for a tap
             that lands on a non-interactive element, so the line above can silently
             fail on a phone and leave the menu stuck open over the results. A
             pointerdown always fires.
             Guarded to non-mouse pointers, so with a mouse NOTHING changes: the click
             handler above still does the closing, on release, exactly as before.
             Containment-checked rather than trusting stopPropagation, because
             pointerdown runs BEFORE click — the toggle's own stopPropagation has not
             happened yet, so a bare close here would be undone (and the menu
             re-opened) by the click that follows. */
          document.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'mouse') return;
            if (sortWrap.contains(e.target)) return;
            sMenu.hidden = true; sToggle.setAttribute('aria-expanded', 'false');
          });
        }
      }
    }

    // ── clear all filters (facets panel or no-results state) ───────────────
    document.querySelectorAll('[data-tyt-walks-clear]').forEach(function (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state = { country: 'all', trail: 'all', distance: 'all', difficulty: 'all', query: '', sort: state.sort };
        if (bar) {
          bar.querySelectorAll('[data-tyt-walks-dd]').forEach(function (dd) {
            dd.classList.remove('is-active');
            var valueEl = dd.querySelector('[data-tyt-walks-dd-value]');
            if (valueEl) valueEl.textContent = 'All';
            dd.querySelectorAll('[data-tyt-walks-dd-option]').forEach(function (o) {
              o.setAttribute('aria-selected', o.getAttribute('data-value') === 'all' ? 'true' : 'false');
              o.hidden = false;
            });
            var s = dd.querySelector('[data-tyt-walks-dd-search]');
            if (s) s.value = '';
          });
          var ms = bar.querySelector('[data-tyt-walks-search-input]');
          if (ms) ms.value = '';
        }
        apply();
      });
    });

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
